<template>
  <div>
    <ReactWrapper :component="MethodModal" :props="props" />
  </div>
</template>

<script>
  import { MethodModal } from '../../../../../frontendV2/dist/reactComponents';
  import ReactWrapper from '@/components/blocks/reactComponents/ReactWrapper';

  export default {
    name: 'MethodModal',

    components: {
      ReactWrapper,
    },

    data: () => ({
      MethodModal,
    }),

    props: {
      isOpen: {
        type: Boolean,
        default: false,
      },
      deviceId: {
        type: String,
        default: null,
      },
      method: {
        type: Object,
      },
      methodOverride: {
        type: Object,
        default: null,
      },
      deviceConfiguration: {
        type: Object,
        required: true,
      },
      isReadOnly: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      props() {
        return {
          isOpen: this.isOpen,
          deviceId: this.deviceId,
          onClose: this.onClose,
          onCreate: this.onCreate,
          method: this.method,
          methodOverride: this.methodOverride,
          deviceConfiguration: this.deviceConfiguration,
          onEdit: this.onEdit,
          isReadOnly: this.isReadOnly,
        };
      },
    },

    methods: {
      onClose() {
        this.$emit('close');
      },

      onCreate(method) {
        this.$emit('create', method);
      },

      onEdit(method) {
        this.$emit('edit', method);
      },
    },
  };
</script>
